export default "__VITE_ASSET__Cjv29ABr__"